import { CurrencyPipe, DatePipe } from "@angular/common";
import { SplitInterpolation, ThrowStmt } from "@angular/compiler";
import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { errorMonitor } from "events";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { element } from "protractor";
import { Observable, Subscription, zip } from "rxjs";
import { first, map, tap } from "rxjs/operators";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoDte } from "src/app/models/tipoDte";
import { Traza } from "src/app/models/Traza";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import * as FileSaver from "file-saver";
import { AbstractControl, FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { EmailData } from "src/app/shared/models/EmailData";
import { EmailAttachment } from "src/app/shared/models/EmailAttachment";
import { MultipleEmailValidator } from "src/app/directives/multi-email.directive";
import { NotaCredito } from "src/app/models/NotaCredito";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { Response } from "src/app/shared/models/Response";
import * as JSZip from "jszip";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { ConfigDocumentosRecibidos } from "./config-documentos-recibidos";
import { DteRecibidoFilter } from "src/app/models/Dte/DteRecibidoFilter";
import { DocumentosRecibidosService } from "src/app/services/documentos-recibidos.service";
import { DteRecibido } from "src/app/models/Dte/DteRecibido";
import { AcuseRecibo } from "src/app/models/Dte/AcuseRecibo";
import { Conciliacion } from "src/app/models/Dte/Conciliacion";
import { SessionUser } from "src/app/shared/models/sessionUser";
import * as moment from "moment";
import { TipoAcuseRecibo } from "src/app/models/Dte/TipoAcuseRecibo";
import { RespuestaEstadoDte } from "src/app/models/Dte/RespuestaEstadoDte";
import { PermissionService } from "src/app/services/permission.service";
import { Permission } from "src/app/shared/models/Permission";
import { CasillaDteRecibido } from "src/app/models/CasillaDteRecibidos/CasillaDteRecibido";
import { CasillaDteRecibidoService } from "src/app/services/CasillaDteRecibido/casilla.dte.recibido.service";
import { EstadoValidacionDteRecibido } from "src/app/models/Proveedor/EstadoValidacionDteRecibido.enum";
import { AcuseReciboMasivo } from "src/app/models/Dte/AcuseReciboMasivo";
import { SortType } from "@swimlane/ngx-datatable";
import { EmisorService } from "src/app/services/emisor.service";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { AdicionalType } from "src/app/shared/models/AdicionalType.enum";
import { ExportModalComponent } from "../../layout/export-modal/export-modal.component";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-documentos-recibidos",
	templateUrl: "./documentos-recibidos.component.html",
	styleUrls: ["./documentos-recibidos.component.scss"],
})
export class DocumentosRecibidosComponent implements OnInit {
	SortType = SortType;
	public withOutAccess: boolean = false;
	public tracesModal: NgbModalRef;
	public statusModal: NgbModalRef;
	public detailModal: NgbModalRef;
	loading: boolean = false;
	public configLocal = ConfigDocumentosRecibidos;
	public planActual = this.planUsuarioService.getActualPlan();
	public filter = new DteRecibidoFilter();
	public page = new Page();
	public rowsMantenedor: DteRecibido[] = [];
	public isSuperAdm: Boolean;
	public emisorId: string;
	public empresasSource;
	public casillaCorreoDteRecibido: CasillaDteRecibido = new CasillaDteRecibido();
	public tipoDteSource;
	public selected: DteRecibido[] = []; //dtes seleccionados por checkbox
	public selectedItem: DteRecibido; //dte seleccionado para envio individual y despliegue en modal
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public searchRows: any[] = [];
	public searchCriteria;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public acuseRevisionDte: boolean = false;
	public acuseReciboMercaderias: boolean = false;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	@ViewChild("notesSwal") private notesSwal: SwalComponent;
	@ViewChild("tableMobile") tableRef: any;
	fileIdState: Observable<object>;
	fileIdValue: string;
	registrationIdValue: string;
	public get estadoValidacionDteRecibido(): typeof EstadoValidacionDteRecibido {
		return EstadoValidacionDteRecibido;
	}
	public motivos = [
		{ name: "Aceptado", disabled: !this.permissions.getPermission("50-10-26-10").asignado },
		{ name: "Aceptado con Reparos", disabled: !this.permissions.getPermission("50-10-26-12").asignado },
		{ name: "Rechazado", disabled: !this.permissions.getPermission("50-10-26-14").asignado },
	];
	public permissionMotivos: Permission[] = [this.permissions.getPermission("50-10-26-10"), this.permissions.getPermission("50-10-26-12"), this.permissions.getPermission("50-10-26-14")];
	public motivoAcuse = undefined;
	public tipoRechazoAcuse;
	public comentarioAcuse = "";
	public dteRejected: DteRecibido = new DteRecibido();
	public dteToShow: DteRecibido = new DteRecibido();
	public tracesToShow: Traza[] = [];
	public AcuseReciboTypes;
	public RespuestasEstadoAcuseDte;
	public AcuseReciboRejectedTypes: any[] = [];
	public usuarioId: string;
	private closeActionsHandler: any;
	public datePickerConciliacion: NgbModalRef;
	public dateConciliacion: any = { startDate: null, endDate: null };
	private modalAcuseMasivo: NgbModalRef;
	public emisorSource: Emisor[];
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	private modalInformePago: any;
	public todayString = moment();
	public minDate = moment().subtract(5, 'months').startOf('month');
	public acuseModoAceptar: boolean = false;
	public componentStarted: boolean = false;
	public validDate: boolean = true;
	public motivoAcuseDeshabilitado: boolean = undefined;
	constructor(
		private dteRecibidoService: DocumentosRecibidosService,
		private dteService: DteEmitidosService,
		private casillaService: CasillaDteRecibidoService,
		private ref: ChangeDetectorRef,
		public activatedRoute: ActivatedRoute,
		private tokenService: TokenStorageService,
		private localStorage: LocalStorageService,
		public utilities: UtilitiesService,
		private modalService: NgbModal,
		private datePipe: DatePipe,
		private currencyPipe: CurrencyPipe,
		private formBuilder: FormBuilder,
		private tokenContainer: TokenStorageService,
		private emisorService: EmisorService,
		private formConfig: FormrulesConfigService,
		public permissions: PermissionService,
		private planUsuarioService: PlanUsuarioService,
		private sessionUserService: SessionUserService
	) {
		this.emisorSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.emisorId = this.tokenService.getCompany();
		this.casillaService.getCasillaDteRecibidoByEmisor(this.emisorId).subscribe(
			(res) => {
				this.casillaCorreoDteRecibido = res.data;
			},
			(err) => {
				this.currentSwal.icon = "info";
				this.currentSwal.title = "Sin Casilla de Correo";
				this.currentSwal.text = "El emisor no tiene ninguna casilla de correo activa";
				this.currentSwal.fire();
			}
		);
		this.isSuperAdm = this.tokenService.getUser().superAdmin;
		this.usuarioId = (this.tokenContainer.getUser() as SessionUser).id;
		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.AcuseReciboTypes = JSON.parse(this.localStorage.getTipoAcuseRecibo()) as TipoAcuseRecibo[];
		this.RespuestasEstadoAcuseDte = JSON.parse(this.localStorage.getRespuestaEstadoDte()) as RespuestaEstadoDte[];
		this.checkStateId();
		this.starterPage();
		this.filter.tipoDteId = "";
		if (this.fileIdState) {
			this.getFileIdInState();
		}
		this.filter.emisorId = this.emisorId;
		this.filter.estado = 0;
		this.AcuseReciboTypes.forEach((element) => {
			if (element.codigo != 0 && element.codigo != 2) {
				this.AcuseReciboRejectedTypes.push(element);
			}
		});
		this.tipoRechazoAcuse = this.AcuseReciboRejectedTypes[0];
	}

	checkStateId() {
		this.fileIdState = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
	}

	getFileIdInState() {
		this.loading = true;
		this.fileIdState
			.subscribe((result) => {
				this.fileIdValue = result["paramId"];
				this.registrationIdValue = result["registrationId"];
				let emisorImportado = result["filterEmisor"];
				this.filter.emisorId = emisorImportado ? emisorImportado : this.emisorId;
				let fechaDesde = result["fechaDesde"];
				let fechaHasta = result["fechaHasta"];
				if (fechaDesde && fechaHasta) {
					this.filter.fechaDesde = fechaDesde;
					this.filter.fechaHasta = fechaHasta;
				}
				let codigoSii = result["codigoSii"];
				if (codigoSii) {
					var tipoDte = this.tipoDteSource.find((tipo) => tipo.codigosii == codigoSii) as TipoDte;
					if (tipoDte != undefined) {
						this.filter.tipoDteId= tipoDte.tipoDteId;
					}
				}
				let nulo = result["nulos"];
				if (nulo != undefined) {
					this.filter.nulos = nulo;
				}

				this.loading = false;
			})
			.add(() => {
				this.loading = false;
			});
	}

	starterPage() {
		this.page.pageNumber = 0;
		this.page.pageSize = 10;
		this.selectedAllItemsInPage[this.page.pageNumber] = false;
	}
	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
	
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
	  
	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.ref.detectChanges();
		this.setPage({ offset: 0 });
	}

	searchElementsByFilter(event) {
		//se toman los valores del filtro que necesite el endpoint de filtro para dte
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);

		this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : "";
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.fechaVencimientoDesde = event.fechaVencInicio;
		this.filter.fechaVencimientoHasta = event.fechaVencFin;
		this.filter.fechaRecepcionDesde = event.fechaRecepInicio;
		this.filter.fechaRecepcionHasta = event.fechaRecepFin;
		this.filter.estado = event.estado != null ? event.estado : "";
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.estadoSii = event.estadoDte;
		this.filter.respuestaEstadoDte = event.respuestaEstadoDte != null ? event.respuestaEstadoDte : "";
		this.filter.nulos = event.nulos == null ? null : event.nulos;
		this.filter.tieneNC = event.tieneNC == null ? null : event.tieneNC;
		this.filter.cedida = event.cedida == null ? null : event.cedida;
		this.setPage({ offset: 0 });
	}

	filterConcordance(configCriterias, dteRecibidoFilter: DteRecibidoFilter, eventFilter): DteRecibidoFilter {
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				dteRecibidoFilter[criteria] = "";
			}
		});
		return dteRecibidoFilter;
	}

	setPage(pageInfo) {
		const adicionales = this.localStorage.getAdicionales();
		const adicionalRecibidos = adicionales.find((ad) => ad.idAdicional == AdicionalType.Recibidos);
		if(this.isSuperAdm || this.planActual.nombrePlan != "Independiente" || adicionalRecibidos != undefined)
		{
			this.loading = true;
			this.selected = [];
			this.page.pageNumber = pageInfo.offset;
			let localPage = JSON.parse(JSON.stringify(this.page));
			//this.page.pageNumber += 1;
			localPage.pageNumber += 1;
			this.dteRecibidoService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as DteRecibido[];
					this.ref.detectChanges();
					elements.forEach((row) => {
						this.setEmisorToElement(row);
						this.setTipoDteToElement(row);
						if (row.acuseReciboId != null && row.respuestaEstadoId != null) {
							var respuesta = "";
							var acuse = "";
							this.RespuestasEstadoAcuseDte.forEach((element) => {
								if (element.id == row.respuestaEstadoId) respuesta = element.descripcion;
							});
							this.AcuseReciboRejectedTypes.forEach((element) => {
								if (element.id == row.acuseReciboId) acuse = element.nombre;
							});
							row.estadoFinal = "," + acuse;
						}
					});
					this.rowsMantenedor = [...elements];
					this.ref.detectChanges();
					this.setPagefromResponse(this.page, pagedData);
				},
				(error) => {
					if(error.error.status == 401){
						this.withOutAccess = true;
					}
					else {
						this.currentSwal.icon = "error";
						this.currentSwal.title = "Error en la solicitud";
						this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
						this.currentSwal.fire();
					}				
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
		}
		else {			
			this.withOutAccess = true;
		}
		
	}

	setPagefromResponse(currentPage: Page, data: PagedResponse<DteRecibido>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}
	setEmisorToElement(row: DteRecibido) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
		row.emisorAsociado = empresaAsociada;
	}

	setTipoDteToElement(row: DteRecibido) {
		let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
		row.nombreTipoDte = tipoDteAsociado.abreviacion;
	}

	getId(row) {
		return row.dteId;
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	getCellClass({ row, column, value }): any {
		return row.codigoTipoDte === 61 ? "is-monto-nota-credito number-table-alignment" : "number-table-alignment";
	}

	// getAllRowsByFilter(currentPageRef: Page, currentFilter: DteRecibidoFilter) {
	// 	let fullPage: Page = new Page();
	// 	fullPage.pageSize = currentPageRef.totalElements;
	// 	fullPage.pageNumber = 0;
	// 	fullPage.totalElements = currentPageRef.totalElements;
	// 	fullPage.totalPages = 1;
	// 	this.loading = true;
	// 	this.dteRecibidoService.getDataByPage(currentFilter, fullPage).subscribe(
	// 		(result) => {
	// 			let elements = result.data as DteRecibido[];
	// 			this.ref.detectChanges();
	// 			elements.forEach((row) => {
	// 				this.setEmisorToElement(row);
	// 				this.setTipoDteToElement(row);
	// 			});
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.exportExcelData(elements);
	// 		},
	// 		(error) => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.currentSwal.icon = "error";
	// 			this.currentSwal.title = "Error al exportar";
	// 			this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
	// 			if (error.error.message) {
	// 				this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
	// 			}
	// 		},
	// 		() => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 		}
	// 	);
	// }


	downloadXml(dte: DteRecibido) {
		this.dteRecibidoService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				FileSaver.saveAs(blobXml, dte.folio + "_" + "dte.xml");
				this.loading = false;
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = "No fue posible obtener el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
			}
		);
	}
	downloadPDF(dte: DteRecibido) {
		this.loading = true;
		this.dteRecibidoService.getPdf(dte.dteId, false).subscribe(
			(result) => {
				// this.responseToPdfDownload(result.data, dte);

				this.loading = false;
				this.ref.detectChanges();
				let pdfB64 = result.data;
				let pdfBlob = this.utilities.convertB64ToBlob(pdfB64, "application/pdf");
				if (pdfBlob.size > 0) {
					let fileURL = URL.createObjectURL(pdfBlob);
					this.popupCenter(fileURL, "PDF", 600, 800);
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde" + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}
	downloadPDFCedible(dte: DteRecibido) {
		this.loading = true;
		this.dteRecibidoService.getPdf(dte.dteId, true).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, dte);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf cedible";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}
	responseToPdfDownload(responseB64, currentDte: DteRecibido) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, currentDte.folio + "_dte.pdf");
		this.loading = false;
		this.ref.detectChanges();
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	multipleDocumentDownload(fileType) {
		if (this.selected.length > 0) {
			var validos = true;
			this.selected.forEach((dte) => {
				if (!dte.conArchivo) validos = false;
			});
			if (!validos) {
				Swal.fire({
					icon: "info",
					title: "Advertencia en descarga",
					text: "Solo se puede descargar " + fileType + " masivamente de documentos obtenidos desde el correo",
				});
				return;
			}
			this.loading = true;
			let dteIds = this.selected.map(dte => dte.dteId);
			this.getDownloadFilesObservable(dteIds, fileType).subscribe(
                (response) => {
					this.loading = false;
                    const blob = new Blob([response], { type: 'application/zip' });
                    const dateOfDownLoad = this.datePipe.transform(Date.now(), 'dd/MM/yyyy');
                    FileSaver.saveAs(blob, `documentos_recibidos_${dateOfDownLoad}_${fileType}.zip`);

                    this.currentSwal.icon = "success";
                    this.currentSwal.title = "Descarga de documentos";
                    this.currentSwal.text = "Los documentos seleccionados se han descargado";
                    this.currentSwal.fire();
					this.ref.detectChanges();
                },
                (err) => {
					this.loading = false;
					console.log(err);
                    this.currentSwal.icon = "error";
                    this.currentSwal.title = "Error en exportación";
                    this.currentSwal.text = "No ha sido posible descargar los documentos seleccionados.\nFavor intentar más tarde o contactar a su administrador.";
                    if (err.error.errors) {
                        this.currentSwal.text += this.utilities.setErrorMessageFromArray(err.error);
                    }
                    this.currentSwal.fire();
					this.ref.detectChanges();					
                },
                () => {
                    this.loading = false;
					this.ref.detectChanges();
                }
            );
		}
		else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	getDownloadFilesObservable(Ids: string[], type: string): Observable<any> {
		const downloadRequest = {
            dteIds: Ids,
            fileType: type
        };
		return this.dteRecibidoService.getZip(downloadRequest);
	}


	statusDocModal(modalRef, dte: DteRecibido) {
		this.loading = true;
		this.motivoAcuse = this.motivos[0];
		this.tipoRechazoAcuse = this.AcuseReciboRejectedTypes[0];
		this.comentarioAcuse = "";
		this.dteRejected = dte;
		// if (dte.estado == 2) {
		// 	this.motivoAcuse = this.motivos[2];
		// 	this.motivoAcuse.disabled = false;
		// 	this.motivos.forEach((motiv) => (motiv.name != "Rechazado" ? (motiv.disabled = true) : (motiv.disabled = false)));
		// 	this.motivoAcuseDeshabilitado = true;
		// } else {
		// 	this.motivoAcuseDeshabilitado = undefined;
		// 	this.motivos.forEach((motiv) => (motiv.disabled = false));
		// }

		this.motivoAcuseDeshabilitado = undefined;
			this.motivos.forEach((motiv) => (motiv.disabled = false));

		this.loading = false;
		this.ref.detectChanges();
		this.statusModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	statusDoc(refuseForm: NgForm) {
		this.loading = true;
		if (this.motivoAcuse == this.motivos[0]) this.comentarioAcuse = "Aceptado";
		if (this.comentarioAcuse.trim() != "") {
			var acuse: AcuseRecibo = new AcuseRecibo();
			acuse.id = this.dteRejected.dteId;
			acuse.emisorId = this.emisorId;
			acuse.usuarioId = this.usuarioId;
			acuse.rejectionType = null;
			acuse.acuseRevisionDte = this.acuseRevisionDte;
			acuse.acuseReciboMercaderias = this.acuseReciboMercaderias;
			if (this.motivoAcuse == this.motivos[0]) acuse.response = 3;
			if (this.motivoAcuse == this.motivos[1]) acuse.response = 4;
			if (this.motivoAcuse == this.motivos[2]) acuse.response = 5;
			if (acuse.response == 5) acuse.rejectionType = this.tipoRechazoAcuse.codigo;
			acuse.description = this.comentarioAcuse;
			this.dteRecibidoService.acuseRecibo(acuse).subscribe(
				(res) => {
					if (res.data) {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Estado del Documento Actualizado",
							showCloseButton: true,
							html: "<div style='text-align:center;'><p>" + "Se actualizo el estado de acuse del documento " + this.dteRejected.nombreTipoDte + " folio " + this.dteRejected.folio + "</p></div>",
						});
						this.statusModal.close();
						this.setPage({ offset: 0 });
					} else {
						this.loading = false;
						this.ref.detectChanges();
						this.currentSwal.icon = "error";
						this.currentSwal.title = "Error al Actualizar Documento";
						this.currentSwal.text = "No se pudo actualizar el acuse del documento";
						this.currentSwal.fire();
					}
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error al Actualizar Documento";
					this.currentSwal.text = this.utilities.setErrorMessageFromArray(err.error);
					this.currentSwal.fire();
				}
			);
		} else {
			this.loading = false;
			this.ref.detectChanges();
			this.currentSwal.icon = "info";
			this.currentSwal.title = "Datos Incompletos";
			this.currentSwal.text = "Comentario vacio. Ingresa un comentario asociado al acuse de recibo del documento";
			this.currentSwal.fire();
		}
	}

	openTraceShowModal(traceRef, row: DteRecibido) {
		this.loading = true;
		this.dteToShow = row;
		this.dteRecibidoService.getTrace(this.dteToShow.dteId).subscribe(
			(result) => {
				this.tracesToShow = result.data as Traza[];
				this.loading = false;
				this.ref.detectChanges();
				this.tracesModal = this.modalService.open(traceRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en Trazabilidad";
				this.currentSwal.text = "No es posible obtener la trazabilidad de este documento. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}

	DetailDteModal(modalRef, row: DteRecibido) {
		this.loading = true;
		this.motivoAcuse = this.motivos[0];
		this.comentarioAcuse = "";
		this.dteToShow = row;
		this.loading = false;
		this.ref.detectChanges();
		this.detailModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	conciliacion() {
		this.loading = true;
		let conciliacion = new Conciliacion();
		conciliacion.emisorId = this.emisorId;
		conciliacion.usuarioId = this.usuarioId;
		conciliacion.dateString = this.datePipe.transform(new Date(), "dd/MM/yyyy");
		this.dteRecibidoService.conciliacionMensual(conciliacion).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Conciliacion Mensual Realizada",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + res.message + "</p></div>",
				});
				this.setPage({ offset: 0 });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en la Conciliación";
				this.currentSwal.text = "No es posible realizar la conciliación Mensual. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}

	openDatePickerConciliacion(modalRef, month: boolean) {
		if (month) this.locale.format = "MM/YYYY";
		else this.locale.format = "DD/MM/YYYY";
		//this.dateConciliacion = null;
		this.dateConciliacion.startDate = moment().startOf("day");
		this.dateConciliacion.endDate = moment().subtract(1, "days").startOf("day");
		this.datePickerConciliacion = this.modalService.open(modalRef, {
			windowClass: "",
			size: "md",
			centered: true,
		});
	}
	conciliacionRequest(conciliacionRequest: NgForm) {

		if (conciliacionRequest.valid && this.validDate) {
			Swal.fire({
				title: "¿Desea conciliar los dtes en el SII?",
				text: "Se buscará y conciliará en el S.I.I. los registros de dte que hayan sido recibidos",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Si, conciliar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.isConfirmed) {
					let conciliacion = new Conciliacion();
					conciliacion.emisorId = this.emisorId;
					conciliacion.usuarioId = this.usuarioId;
					conciliacion.dateString = moment(this.dateConciliacion.startDate).format("L");
					this.loading = true;
					if (this.locale.format == "MM/YYYY") {
						this.dteRecibidoService.conciliacionMensual(conciliacion).subscribe(
							(res) => {
								this.loading = false;
								this.ref.detectChanges();
								Swal.fire({
									icon: "success",
									title: "Conciliacion Mensual Realizada",
									showCloseButton: true,
									html: "<div style='text-align:center;'><p>" + res.message + "</p></div>",
								});
								this.setPage({ offset: 0 });
							},
							(err) => {
								this.loading = false;
								this.ref.detectChanges();
								this.currentSwal.icon = "error";
								this.currentSwal.title = "Error en la Conciliación";
								this.currentSwal.text = "No es posible realizar la conciliación Mensual. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error);
								this.currentSwal.fire();
							}
						);
					} else {
						this.dteRecibidoService.conciliacion(conciliacion).subscribe(
							(res) => {
								this.loading = false;
								this.ref.detectChanges();
								Swal.fire({
									icon: "success",
									title: "Conciliacion Realizada",
									showCloseButton: true,
									html: "<div style='text-align:center;'><p>" + res.message + "</p></div>",
								});
								this.setPage({ offset: 0 });
								this.datePickerConciliacion.close();
							},
							(err) => {
								this.loading = false;
								this.ref.detectChanges();
								this.currentSwal.icon = "error";
								this.currentSwal.title = "Error en la Conciliación";
								this.currentSwal.text = "No es posible realizar la conciliación. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error);
								this.currentSwal.fire();
								this.datePickerConciliacion.close();
							}
						);
					}
				}
			});
		}
	}
	detectChangeDate(event) {
		this.validDate = true;
		let fromDate: any;
		if (event.startDate != null) {
			this.dateConciliacion = event;
		} else {
			if (event.target != null && event.target.value != null) {
				this.validDate = moment(event.target.value, this.locale.format, true).isValid();
				if (this.validDate) {
					fromDate = new Object();
					fromDate.startDate = moment(event.target.value, this.locale.format);
					this.dateConciliacion = fromDate;
				}
			}
		}
	}

	messageForNotFoundDocument(documentType: string, index: number, selectedArray: any) {
		let relatedDTE = selectedArray[index];
		return "No fue posible obtener el documento de tipo " + documentType + " para el documento del proveedor " + relatedDTE.razonSocialProveedor + " con número de folio " + relatedDTE.folio;
	}

	responseItemErrorFromArray(response: Response<any>, fileType: string, index: number, selectedArray: any): [boolean, string] {
		let valid = true;
		let errorMessage = "";
		if (fileType == "xml" && (response.data == null || !response.data.xml)) {
			valid = false;
			errorMessage = this.messageForNotFoundDocument(fileType, index, selectedArray);
		}
		return [valid, errorMessage];
	}

	openAcuseMasivoModal(modalRef, aceptaDocs: boolean) {
		if (this.selected.length <= 0) {
			Swal.fire({
				icon: "error",
				title: "Sin documentos",
				text: "No ha seleccionado ningún documento para el acuse",
			});
			return;
		}
		if (this.checkIfDocIsResolved()) {
			Swal.fire({
				icon: "error",
				title: "Documentos Resueltos",
				text: "Ha seleccionado documentos que ya han recibido acuse",
			});
			return;
		}
		if (this.selected.some((dte) => !dte.acuseHabilitado)) {
			let foliosNoHabilitados = this.selected.map((dte) => {
				if (!dte.acuseHabilitado) {
					return dte.folio.toString();
				}
			}) as string[];
			let foliosNoHabilitadosResponse = foliosNoHabilitados.length > 1 ? foliosNoHabilitados.join(", ") : foliosNoHabilitados;
			Swal.fire({
				icon: "error",
				title: "Acuse no habilitado",
				text: "Dentro de los documentos seleccionados, algunos no se encuentran habilitados para indicar acuse.Detalle: \n" + foliosNoHabilitadosResponse,
			});
			return;
		}
		if (aceptaDocs && this.selected.some((dte) => dte.estado == 2)) {
			let foliosRecibidoSii = this.selected.map((dte) => {
				if (dte.estado == 2) {
					return dte.folio.toString();
				}
			}) as string[];
			let foliosRecibidoSiiResponse = foliosRecibidoSii.length > 1 ? foliosRecibidoSii.join(", ") : foliosRecibidoSii;
			Swal.fire({
				icon: "error",
				title: "Documentos solo recibidos en S.I.I.",
				text: "Dentro de los documentos seleccionados, se encuentran elementos solo recibidos en S.I.I. Dichos documentos solo pueden rechazarse. Detalle de folios: " + foliosRecibidoSiiResponse,
			});
			return;
		}
		this.acuseModoAceptar = aceptaDocs;
		this.modalAcuseMasivo = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	closeAcuseMasivoModal() {
		this.modalAcuseMasivo.close();
	}
	requestAcuseMasivo(event: AcuseReciboMasivo) {
		this.loading = true;
		event.usuarioId = this.usuarioId;
		this.dteRecibidoService.acuseMasivo(event).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Acuse Masivo Exitoso",
					text: "Se ha realizado exitosamente el acuse de los documentos seleccionados",
				});
				this.modalAcuseMasivo.close();
				this.selected = [];
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Acuse",
					text: "Ocurrió un error en el acuse de los documentos seleccionados. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	createHtmlList(): string {
		let response = "<div style='text-align:center'><ul>";
		this.selected.forEach((dte, i) => {
			if (i <= 10) {
				response += "<li style='text-align:left'>Folio: " + dte.folio + " - " + dte.razonSocialProveedor + (dte.fechaRecepcionSii ? " - " + this.datePipe.transform(dte.fechaRecepcionSii, "dd/MM/yyyy") : "") + "</li>";
			}
		});
		if (this.selected.length > 10) {
			let restantes = this.selected.length - 10;
			response += "<li style='text-align:left'>Otros " + restantes + " documentos seleccionados...</li>";
		}
		response += "</ul></div>";
		return response;
	}

	closeInformarPagosModal() {
		this.modalInformePago.close();
	}
	checkIfDocIsResolved() {
		return this.selected.some((doc) => doc.respuestaEstadoId != null);
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}
	onDetailToggle(event) {
	}

	getThirdDotClass(row: DteRecibido): boolean {
		if (row.codigoTipoDte == 52 || row.motivo.toLowerCase() == "contado") return false;
		else if (row.respuestaEstadoId == null && row.diasPendientes == "Vence Hoy") return true;
		const estado = this.RespuestasEstadoAcuseDte.find((e) => e.id === row.respuestaEstadoId);
		if (estado) {
			switch (estado.descripcion.toLowerCase()) {
				case "aceptado":
				case "pago contado":
				case "en el registro":
				case "no reclamado en plazo":
					return false;
				case "aceptado con discrepancias":
					return false;
				case "rechazado":
					return false;
				default:
					return true;
			}
		}
		return true;
	}

	openExportModal() {
		const modalRef = this.modalService.open(ExportModalComponent, {
		  size: 'md',
		  centered: true
		});
	    modalRef.componentInstance.locale = this.locale;	  
		modalRef.componentInstance.type = -1;
		modalRef.componentInstance.totalItems = 15000;	
		modalRef.componentInstance.filter = { ...this.filter };
		modalRef.componentInstance.getPagedDataFunction = this.getDataToExport.bind(this);
		modalRef.componentInstance.exportData.subscribe((data) => {
		  this.loading = data;
		  this.ref.detectChanges();
		});
	  }

	  getDataToExport(filter: DteRecibidoFilter, totalEments: number): Observable<PagedResponse<DteRecibido>> {
		let fullPage: Page = new Page();
		fullPage.pageSize = totalEments;
		fullPage.pageNumber = 0;
		fullPage.totalElements = totalEments;
		fullPage.totalPages = 1;
		this.loading = true;
		return this.dteRecibidoService.getDataByPage(filter, fullPage);
	  }
	  onMotivoAcuseChange(value: any): void {
		if (value === this.motivos[2]) {
		  this.acuseReciboMercaderias = false;
		}
	  }
	  
}
